export const categories = [
  { slug: 'star-collapse', name: '明星塌房', nameEn: 'Star Collapse', description: '明星艺人塌房现场全记录，第一时间追踪事件始末', icon: 'ri-alert-line', color: 'rose' },
  { slug: 'wanghong-expose', name: '网红黑料', nameEn: 'Influencer Exposed', description: '网红博主黑料大起底，真实爆料不遮掩', icon: 'ri-eye-off-line', color: 'amber' },
  { slug: 'daily-contest', name: '每日大赛', nameEn: 'Daily Contest', description: '每日最新热门事件追踪，瓜不停歇', icon: 'ri-fire-line', color: 'orange' },
  { slug: 'video-gossip', name: '吃瓜视频', nameEn: 'Gossip Videos', description: '最全吃瓜视频集合，看视频更过瘾', icon: 'ri-vidicon-line', color: 'emerald' },
  { slug: 'exclusive-reveal', name: '独家爆料', nameEn: 'Exclusive Reveal', description: '全网独家一手爆料，不是二手瓜', icon: 'ri-spy-line', color: 'violet' },
  { slug: 'hot-tracking', name: '黑料追踪', nameEn: 'Black Material Tracking', description: '持续追踪热点事件最新进展', icon: 'ri-radar-line', color: 'slate' },
];

export const articles = [
  {
    slug: 'top-star-live-collapse-2026',
    title: '某顶流男星直播中口误自爆恋情，粉丝当场破防脱粉回踩',
    excerpt: '直播间10万人在线见证塌房现场，一句口误引爆全网热议，超话瞬间沦陷',
    category: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20scene%20with%20a%20celebrity%20on%20live%20stream%20looking%20shocked%20and%20regretful%2C%20dark%20studio%20lighting%20with%20red%20and%20blue%20neon%20accents%2C%20intense%20atmosphere%20with%20floating%20chat%20comments%2C%20cinematic%20composition%2C%20high%20contrast%2C%20moody%20editorial%20photography%20style&width=1920&height=900&seq=hero-a1-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20industry%20scene%20with%20a%20celebrity%20on%20live%20stream%20looking%20shocked%20and%20regretful%2C%20dark%20studio%20lighting%20with%20red%20and%20blue%20neon%20accents%2C%20intense%20atmosphere%2C%20cinematic%20composition&width=600&height=800&seq=thumb-a1-portrait&orientation=portrait',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20entertainment%20reporter%20portrait%2C%20confident%20expression%2C%20simple%20dark%20background%2C%20editorial%20portrait%20photography%2C%20soft%20studio%20lighting&width=200&height=200&seq=avatar-reporter-01&orientation=squarish',
    date: '2026-07-06',
    views: 1280000,
    comments: 45600,
    likes: 89200,
    tags: ['顶流塌房', '直播事故', '恋情曝光'],
    hot: true,
    badge: '爆',
  },
  {
    slug: 'wanghong-fake-products-scandal',
    title: '千万粉美妆博主被扒售卖假货，品牌方联合发律师函',
    excerpt: '多家品牌方联合声明从未授权，涉事博主紧急删除所有推广视频',
    category: 'wanghong-expose',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20cosmetics%20and%20skincare%20products%20scattered%20on%20a%20marble%20table%20with%20legal%20documents%2C%20dramatic%20lighting%20with%20window%20light%20and%20shadows%2C%20investigative%20journalism%20mood%2C%20cinematic%20still%20life%20photography%2C%20dark%20and%20moody%20atmosphere&width=1920&height=900&seq=hero-a2-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Luxury%20cosmetics%20and%20skincare%20products%20scattered%20on%20a%20marble%20table%20with%20legal%20documents%2C%20dramatic%20lighting%20with%20window%20light%20and%20shadows%2C%20investigative%20journalism%20mood&width=600&height=800&seq=thumb-a2-portrait&orientation=portrait',
    author: '黑料挖掘机',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Investigative%20journalist%20portrait%2C%20serious%20expression%2C%20simple%20gray%20background%2C%20editorial%20portrait%20photography%2C%20soft%20directional%20lighting&width=200&height=200&seq=avatar-reporter-02&orientation=squarish',
    date: '2026-07-06',
    views: 956000,
    comments: 32100,
    likes: 67300,
    tags: ['网红翻车', '假货风波', '美妆博主'],
    hot: true,
    badge: '热',
  },
  {
    slug: 'variety-show-contestant-exposed',
    title: '选秀节目选手被曝学历造假，节目组紧急发声明切割',
    excerpt: '网友扒出选手真实学历与简历严重不符，三大平台同步下线相关内容',
    category: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20stage%20with%20dramatic%20spotlight%20on%20empty%20center%2C%20scattered%20documents%20on%20the%20floor%2C%20dark%20background%20with%20stage%20lighting%20beams%2C%20entertainment%20industry%20controversy%2C%20cinematic%20wide%20shot%2C%20theatrical%20lighting&width=1920&height=900&seq=hero-a3-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Television%20variety%20show%20stage%20with%20dramatic%20spotlight%20on%20empty%20center%2C%20scattered%20documents%20on%20the%20floor%2C%20dark%20background%20with%20stage%20lighting%20beams&width=600&height=800&seq=thumb-a3-portrait&orientation=portrait',
    author: '吃瓜一线',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20reporter%20portrait%2C%20alert%20expression%2C%20dark%20minimalist%20background%2C%20editorial%20portrait%20photography%2C%20soft%20rim%20lighting&width=200&height=200&seq=avatar-reporter-03&orientation=squarish',
    date: '2026-07-06',
    views: 2100000,
    comments: 78900,
    likes: 156000,
    tags: ['选秀黑幕', '学历造假', '综艺翻车'],
    hot: true,
    badge: '爆',
  },
  {
    slug: 'celebrity-tax-evasion-2026',
    title: '又一位明星因税务问题被约谈，工作室连夜发文回应',
    excerpt: '税务局官网更新信息引发网友热议，工作室凌晨三点紧急发布声明',
    category: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Official%20government%20building%20exterior%20at%20night%20with%20dim%20lights%20in%20windows%2C%20rainy%20atmosphere%2C%20moody%20cinematic%20photography%2C%20dark%20blue%20and%20gray%20color%20palette%2C%20raining%20street%20scene%20with%20reflections&width=1920&height=900&seq=hero-a4-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Official%20government%20building%20exterior%20at%20night%20with%20dim%20lights%20in%20windows%2C%20rainy%20atmosphere%2C%20moody%20cinematic%20photography%2C%20dark%20blue%20and%20gray%20color%20palette&width=600&height=800&seq=thumb-a4-portrait&orientation=portrait',
    author: '法制吃瓜人',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Legal%20news%20journalist%20portrait%2C%20thoughtful%20expression%2C%20neutral%20gray%20background%2C%20editorial%20portrait%20photography%2C%20soft%20box%20lighting&width=200&height=200&seq=avatar-reporter-04&orientation=squarish',
    date: '2026-07-05',
    views: 1890000,
    comments: 56700,
    likes: 112000,
    tags: ['税务问题', '明星翻车', '法制新闻'],
    hot: false,
    badge: '',
  },
  {
    slug: 'couple-vlogger-divorce-drama',
    title: '情侣博主官宣分手互撕，双方各发长文爆对方猛料',
    excerpt: '500万粉情侣账号突然停更，双方各自发万字长文互曝隐私',
    category: 'video-gossip',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20composition%20showing%20two%20smartphones%20displaying%20long%20text%20messages%2C%20one%20warm%20one%20cool%20lighting%2C%20modern%20apartment%20interior%20blurred%2C%20relationship%20drama%20mood%2C%20cinematic%20split%20composition&width=1920&height=900&seq=hero-a5-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Split%20screen%20composition%20showing%20two%20smartphones%20displaying%20long%20text%20messages%2C%20one%20warm%20one%20cool%20lighting%2C%20modern%20apartment%20interior%20blurred&width=600&height=800&seq=thumb-a5-portrait&orientation=portrait',
    author: '情感观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Social%20media%20reporter%20portrait%2C%20concerned%20expression%2C%20simple%20warm%20background%2C%20editorial%20portrait%20photography%2C%20soft%20natural%20lighting&width=200&height=200&seq=avatar-reporter-05&orientation=squarish',
    date: '2026-07-05',
    views: 756000,
    comments: 28900,
    likes: 54300,
    tags: ['情侣分手', '网红互撕', '情感八卦'],
    hot: false,
    badge: '',
  },
  {
    slug: 'esports-player-match-fixing',
    title: '电竞顶流选手涉嫌假赛被联盟禁赛，俱乐部火线解约',
    excerpt: '联盟官方发布禁赛公告，多家俱乐部连夜排查选手聊天记录',
    category: 'exclusive-reveal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20empty%20gaming%20chairs%2C%20dimmed%20stage%20lights%2C%20monitor%20displaying%20red%20warning%20message%2C%20dramatic%20purple%20and%20blue%20stage%20lighting%2C%20empty%20stadium%20seats%2C%20cinematic%20wide%20angle&width=1920&height=900&seq=hero-a6-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20empty%20gaming%20chairs%2C%20dimmed%20stage%20lights%2C%20monitor%20displaying%20red%20warning%20message%2C%20dramatic%20purple%20and%20blue%20stage%20lighting&width=600&height=800&seq=thumb-a6-portrait&orientation=portrait',
    author: '电竞瓜田',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Esports%20journalist%20portrait%2C%20intense%20expression%2C%20dark%20gaming%20themed%20background%2C%20editorial%20portrait%20photography%2C%20colored%20rim%20lighting&width=200&height=200&seq=avatar-reporter-06&orientation=squarish',
    date: '2026-07-04',
    views: 2340000,
    comments: 89100,
    likes: 178000,
    tags: ['电竞假赛', '禁赛风波', '行业黑幕'],
    hot: true,
    badge: '爆',
  },
  {
    slug: 'actress-secret-marriage-revealed',
    title: '当红女星被拍到与圈外男友领证，工作室默认已结婚',
    excerpt: '网友偶遇民政局门口偶遇，照片细节与时间线完全吻合',
    category: 'exclusive-reveal',
    imageUrl: 'https://readdy.ai/api/search-image?query=Civil%20affairs%20bureau%20building%20entrance%20on%20a%20sunny%20day%2C%20blooming%20cherry%20blossoms%20nearby%2C%20romantic%20yet%20secretive%20atmosphere%2C%20soft%20golden%20hour%20lighting%2C%20warm%20and%20dreamy%20color%20palette%2C%20editorial%20photography&width=1920&height=900&seq=hero-a7-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Civil%20affairs%20bureau%20building%20entrance%20on%20a%20sunny%20day%2C%20blooming%20cherry%20blossoms%20nearby%2C%20romantic%20yet%20secretive%20atmosphere%2C%20soft%20golden%20hour%20lighting&width=600&height=800&seq=thumb-a7-portrait&orientation=portrait',
    author: '娱乐情报局',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Celebrity%20news%20reporter%20portrait%2C%20excited%20expression%2C%20bright%20clean%20background%2C%20editorial%20portrait%20photography%2C%20soft%20beauty%20lighting&width=200&height=200&seq=avatar-reporter-07&orientation=squarish',
    date: '2026-07-04',
    views: 3450000,
    comments: 120000,
    likes: 256000,
    tags: ['隐婚曝光', '民政局偶遇', '圈外恋情'],
    hot: false,
    badge: '',
  },
  {
    slug: 'rapper-diss-track-controversy',
    title: '说唱歌手发歌DISS半个娱乐圈，多位艺人点赞又秒删',
    excerpt: '新歌歌词含沙射影指向多位顶流，评论区秒变战场',
    category: 'hot-tracking',
    imageUrl: 'https://readdy.ai/api/search-image?query=Recording%20studio%20with%20professional%20microphone%20and%20sound%20equipment%2C%20dark%20moody%20atmosphere%20with%20red%20blue%20studio%20lights%2C%20hip%20hop%20music%20production%20scene%2C%20cinematic%20close-up%2C%20high%20contrast%20moody%20photography&width=1920&height=900&seq=hero-a8-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Recording%20studio%20with%20professional%20microphone%20and%20sound%20equipment%2C%20dark%20moody%20atmosphere%20with%20red%20blue%20studio%20lights%2C%20hip%20hop%20music%20production%20scene&width=600&height=800&seq=thumb-a8-portrait&orientation=portrait',
    author: '说唱瓜农',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Music%20journalist%20portrait%2C%20cool%20expression%2C%20dark%20studio%20background%2C%20editorial%20portrait%20photography%2C%20dramatic%20side%20lighting&width=200&height=200&seq=avatar-reporter-08&orientation=squarish',
    date: '2026-07-03',
    views: 1670000,
    comments: 54300,
    likes: 98000,
    tags: ['说唱DISS', '娱乐圈互撕', '评论区大战'],
    hot: false,
    badge: '',
  },
  {
    slug: 'popular-actor-cheating-scandal',
    title: '某视帝被拍到深夜与神秘女子同回酒店，妻子微博沉默',
    excerpt: '狗仔蹲守72小时拍到实锤画面，当事人团队至今未作任何回应',
    category: 'star-collapse',
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dim%20ambient%20lighting%2C%20paparazzi%20perspective%20through%20car%20window%20with%20rain%20drops%2C%20mysterious%20atmosphere%2C%20cinematic%20voyeur%20style%2C%20dark%20blue%20and%20yellow%20lighting%20contrast&width=1920&height=900&seq=hero-a9-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Luxury%20hotel%20entrance%20at%20night%20with%20dim%20ambient%20lighting%2C%20paparazzi%20perspective%20through%20car%20window%20with%20rain%20drops%2C%20mysterious%20atmosphere&width=600&height=800&seq=thumb-a9-portrait&orientation=portrait',
    author: '深夜狗仔队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Paparazzi%20journalist%20portrait%2C%20mysterious%20expression%2C%20dark%20street%20background%2C%20editorial%20portrait%20photography%2C%20low%20key%20lighting&width=200&height=200&seq=avatar-reporter-09&orientation=squarish',
    date: '2026-07-03',
    views: 4560000,
    comments: 167000,
    likes: 312000,
    tags: ['视帝出轨', '深夜约会', '婚姻危机'],
    hot: true,
    badge: '沸',
  },
  {
    slug: 'internet-celebrity-charity-fraud',
    title: '慈善网红被曝善款去向不明，受助对象称从未收到捐款',
    excerpt: '多位自称受助者在评论区发声，相关部门已介入调查',
    category: 'wanghong-expose',
    imageUrl: 'https://readdy.ai/api/search-image?query=Charity%20donation%20box%20with%20scattered%20receipts%20and%20financial%20documents%20on%20wooden%20desk%2C%20questioning%20atmosphere%2C%20dramatic%20side%20lighting%20creating%20long%20shadows%2C%20investigative%20journalism%20mood%2C%20warm%20amber%20dark%20brown%20tones&width=1920&height=900&seq=hero-a10-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Charity%20donation%20box%20with%20scattered%20receipts%20and%20financial%20documents%20on%20wooden%20desk%2C%20questioning%20atmosphere%2C%20dramatic%20side%20lighting%2C%20investigative%20journalism%20mood&width=600&height=800&seq=thumb-a10-portrait&orientation=portrait',
    author: '公益监督员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=NGO%20investigator%20portrait%2C%20determined%20expression%2C%20simple%20neutral%20background%2C%20editorial%20portrait%20photography%2C%20soft%20overhead%20lighting&width=200&height=200&seq=avatar-reporter-10&orientation=squarish',
    date: '2026-07-02',
    views: 987000,
    comments: 34500,
    likes: 72100,
    tags: ['慈善诈骗', '善款去向', '网红翻车'],
    hot: false,
    badge: '',
  },
  {
    slug: 'idol-group-bullying-exposed',
    title: '女团成员被曝队内霸凌，退团成员发长文控诉三年遭遇',
    excerpt: '前成员发出万字控诉信，详细描述被孤立、语言暴力等细节',
    category: 'daily-contest',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20dance%20practice%20room%20with%20mirrors%20reflecting%20empty%20space%2C%20single%20chair%20isolated%20in%20center%2C%20dramatic%20lighting%20from%20one%20side%2C%20K-pop%20training%20room%20aesthetic%2C%20emotional%20lonely%20atmosphere%2C%20cinematic%20composition&width=1920&height=900&seq=hero-a11-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Empty%20dance%20practice%20room%20with%20mirrors%20reflecting%20empty%20space%2C%20single%20chair%20isolated%20in%20center%2C%20dramatic%20lighting%20from%20one%20side&width=600&height=800&seq=thumb-a11-portrait&orientation=portrait',
    author: '女团观察家',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Entertainment%20columnist%20portrait%2C%20empathetic%20expression%2C%20simple%20pink%20toned%20background%2C%20editorial%20portrait%20photography%2C%20soft%20diffused%20lighting&width=200&height=200&seq=avatar-reporter-11&orientation=squarish',
    date: '2026-07-02',
    views: 1890000,
    comments: 67800,
    likes: 134000,
    tags: ['女团霸凌', '队内排挤', '退团爆料'],
    hot: true,
    badge: '热',
  },
  {
    slug: 'movie-star-contract-dispute',
    title: '影帝与经纪公司对簿公堂，天价违约金案今日开庭',
    excerpt: '双方各执一词，法院外聚集大量粉丝和媒体记者',
    category: 'hot-tracking',
    imageUrl: 'https://readdy.ai/api/search-image?query=Courthouse%20exterior%20with%20media%20reporters%20and%20cameras%20gathered%20outside%20on%20steps%2C%20dramatic%20overcast%20sky%2C%20legal%20dispute%20atmosphere%2C%20photojournalism%20style%2C%20gray%20muted%20tones%20with%20flashes%20of%20camera%20lights&width=1920&height=900&seq=hero-a12-landscape&orientation=landscape',
    thumbUrl: 'https://readdy.ai/api/search-image?query=Courthouse%20exterior%20with%20media%20reporters%20and%20cameras%20gathered%20outside%20on%20steps%2C%20dramatic%20overcast%20sky%2C%20legal%20dispute%20atmosphere%2C%20photojournalism%20style&width=600&height=800&seq=thumb-a12-portrait&orientation=portrait',
    author: '法庭速递员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Court%20reporter%20portrait%2C%20serious%20expression%2C%20neutral%20office%20background%2C%20editorial%20portrait%20photography%2C%20clean%20professional%20lighting&width=200&height=200&seq=avatar-reporter-12&orientation=squarish',
    date: '2026-07-01',
    views: 1230000,
    comments: 43200,
    likes: 87600,
    tags: ['天价违约金', '经纪纠纷', '法庭直播'],
    hot: false,
    badge: '',
  },
];

export const testimonials = [
  {
    id: 1,
    username: '吃瓜不嫌事大',
    avatar: 'https://readdy.ai/api/search-image?query=Casual%20young%20Chinese%20person%20portrait%2C%20playful%20expression%2C%20simple%20orange%20background%2C%20social%20media%20avatar%20style%2C%20clean%20and%20modern%2C%20warm%20lighting&width=200&height=200&seq=user-avatar-01&orientation=squarish',
    rating: 4.9,
    comment: '这个网站太顶了！每次有大瓜我第一个冲来这里，信息更新速度比微博还快，而且整理得很清楚，不用在各个平台切来切去找线索。吃瓜神器！',
    platform: '微博用户',
  },
  {
    id: 2,
    username: '理性吃瓜人',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20young%20Chinese%20person%20portrait%2C%20calm%20expression%2C%20simple%20teal%20background%2C%20social%20media%20avatar%20style%2C%20clean%20modern%2C%20soft%20lighting&width=200&height=200&seq=user-avatar-02&orientation=squarish',
    rating: 4.8,
    comment: '之前总在群里被各种二手瓜带节奏，现在直接看51吃瓜就行了，一手信息源整理得明明白白，时间线梳理也专业。拯救了我的信息焦虑。',
    platform: '豆瓣用户',
  },
  {
    id: 3,
    username: '前线瓜农',
    avatar: 'https://readdy.ai/api/search-image?query=Trendy%20young%20Chinese%20person%20portrait%2C%20enthusiastic%20expression%2C%20simple%20purple%20background%2C%20social%20media%20avatar%20style%2C%20clean%20modern%2C%20bright%20lighting&width=200&height=200&seq=user-avatar-03&orientation=squarish',
    rating: 4.7,
    comment: '每日大赛栏目我天天追，比追剧还上头！而且评论区氛围好，大家都是理性讨论不引战，难得在吃瓜领域有这么干净的社区。',
    platform: '小红书用户',
  },
  {
    id: 4,
    username: '深夜瓜友',
    avatar: 'https://readdy.ai/api/search-image?query=Chill%20young%20Chinese%20person%20portrait%2C%20relaxed%20expression%2C%20simple%20green%20background%2C%20social%20media%20avatar%20style%2C%20clean%20modern%2C%20warm%20dim%20lighting&width=200&height=200&seq=user-avatar-04&orientation=squarish',
    rating: 5.0,
    comment: '51吃瓜就是我的睡前读物，每天不刷一遍睡不着。黑料追踪那个栏目做得特别好，持续跟进不烂尾，比某些媒体强太多。',
    platform: '知乎用户',
  },
];

export const brandStory = {
  title: '全网最新吃瓜资源与爆料入口',
  subtitle: '51今日吃瓜网成立于2024年，是国内领先的娱乐资讯聚合平台。我们致力于为吃瓜群众提供全网最新、最全、最真的吃瓜资源和爆料信息。从明星塌房到网红翻车，从每日大赛到独家揭秘，51吃瓜网始终站在吃瓜第一线，用心做好每一条信息的核实与整理。',
  longText: '作为一个独立的内容聚合平台，我们不做二手瓜的搬运工，而是坚持追根溯源，为用户还原事件全貌。我们的编辑团队由资深娱乐记者、数据挖掘专家和内容策划组成，7×24小时不间断追踪全网热点，通过多源交叉验证确保信息的真实性和时效性。两年来，51吃瓜网已累计追踪报道超过5000个热点事件，服务超过100万吃瓜群众，成为中文互联网最具影响力的吃瓜信息集散地之一。',
};